/* eslint promise/no-nesting:0 */
import {Component} from 'react';
import PropTypes from 'prop-types';
import BrachIOConfig from './config';
class BranchIO extends Component {
  static contextTypes = {
    omniture: PropTypes.object,
    globalRegistry: PropTypes.object
  };

  componentDidMount() /* istanbul ignore next: client side code */ {
    const visitorImportPromise = import(/* webpackChunkName: "swi-visitorAPI" */ 'exports-loader?visitor!@stubhub/thirdpartylibs/dist/visitorAPI');
    const branchImportPromise = import(/* webpackChunkName: "swi-branchio" */ 'exports-loader?branch!@stubhub/thirdpartylibs/dist/branch-io-2.26.1.min');

    return Promise.all([visitorImportPromise, branchImportPromise]).then((imports) => {
      const visitorChunkPromise = imports[0].default;
      const branchioChunkPromise = imports[1].default;
      return Promise.all([visitorChunkPromise, branchioChunkPromise]).then((values) => BrachIOConfig.init(...values, this.context));
    });
  }

  render () {
    return null;
  }
}

export default BranchIO;
